import React from "react";
import styles from "./NavbarAdmin.module.css";
import logo2 from "../../assets/logo/logo2.png";
import { Link } from "react-router-dom";

const NavbarAdmin = () => {
  return (
    <nav className={styles.navbar}>
      <div className={styles.logo}>
        <Link to="/portal-admin-proveedor/inicio">
          <img src={logo2} alt="logo" />
        </Link>
      </div>
    </nav>
  );
};

export default NavbarAdmin;
